import { render, staticRenderFns } from "./DesignLibraryPassword.vue?vue&type=template&id=2ab4805a&"
import script from "./DesignLibraryPassword.vue?vue&type=script&lang=ts&"
export * from "./DesignLibraryPassword.vue?vue&type=script&lang=ts&"
import style0 from "./DesignLibraryPassword.vue?vue&type=style&index=0&id=2ab4805a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports